import req from '@/utils/request'

export const getWalletAmount = (params) => {
  return req.get('/member/wallet/amount/phone', params)
}